<template>
  <div class="container">
    <div class="tit">{{ $t('about').title }}</div>
    <div class="info">
      <!-- logo -->
      <div class="logo"> <img class="img" :src="platformLogo" /></div>
      <!-- 名称 -->
      <div class="title">{{ platformName }}</div>
      <!-- 版本 -->
      <div class="lable">{{ $t('about').version }} 1.0.1</div>
      <div class="content">
        <!-- 关于 -->
        <div class="item" @click="goContent(3, '')">
          <div class="left">
            <span>{{ $t('about').about }} {{ platformName }}</span>
          </div>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
        <!-- 产品介绍 -->
        <div class="item" @click="goContent(4, '')">
          <div class="left">
            <span>{{ $t('about').ProductIntroduction }}</span>
          </div>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
        <!-- 服务条款 -->
        <div class="item" @click="goContent(5, '')">
          <div class="left">
            <span>{{ $t('about').Termofservice }}</span>
          </div>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
        <!-- 隐私协议 -->
        <div class="item" @click="goContent(0, $t('about').PrivacyAgreement)">
          <div class="left">
            <span>{{ $t('about').PrivacyAgreement }}</span>
          </div>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
        <!-- 风险提示 -->
        <div class="item" @click="goContent(6, '')">
          <div class="left">
            <span>{{ $t('about').Riskstatement }}</span>
          </div>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import systemApi from '@/api/system'
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  data() {
    return {
      platformName: localStorage.getItem('platformName'),
      platformLogo: localStorage.getItem('platformLogo')
    }
  },
  computed: {
    ...mapGetters(['basicConfig'])
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    // 跳转内容
    async goContent(type, title) {
      const res = await systemApi.getContentList({ type: type })
      this.$router.push({ name: 'Detail', query: { Name: title, id: res.rows[0].contentLocalizationId } })
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 100px;
  width: 100%;
  background: var(--background_color);

  .tit {
    font-size: 36px;
    font-weight: bold;
    color: var(--text_color);
    margin: 0 auto;
    max-width: 1280px;
    padding-bottom: 40px;
    border-bottom: 1px solid var(--info_color);
  }

  .info {
    margin: 0 auto;
    max-width: 780px;

    .logo {
      padding-top: 90px;
      text-align: center;

      .img {
        border-radius: 15px;
        width: 100px;
        height: 100px;
      }
    }

    .title {
      margin-top: 10px;
      text-align: center;
      font-size: 21px;
      font-weight: bold;
      color: var(--primary_color);
    }

    .lable {
      margin-top: 10px;
      text-align: center;
      font-size: 13px;
      color: var(--ntext_color);
    }

    .content {
      margin-top: 30px;

      .item {
        padding: 30px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid var(--info_color);

        .left {
          display: flex;
          align-items: center;

          span {
            font-size: 18px;
            color: var(--text_color);
          }
        }

        span {
          font-size: 14px;
          color: var(--ntext_color);
          margin-right: 10px;
        }
      }

      .item:hover {
        background: var(--info_color);
        border-radius: 10px;
        border: 1px solid var(--primary_color);
      }
    }
  }
}
</style>
